export const TOGGLE_ACTIVE = 'TOGGLE_ACTIVE'
export const TOGGLE_HOURS = 'TOGGLE_HOURS'

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT'

export const FETCH_ATTACHMENT_LIST = 'FETCH_ATTACHMENT_LIST'

export const CHANGE_PAGE = 'CHANGE_PAGE'
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER'
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER'
export const FETCH_CUSTOMER_LIST = 'FETCH_CUSTOMER_LIST'
export const FETCH_CUSTOMER_LIST_SUCCESS = 'FETCH_CUSTOMER_LIST_SUCCESS'
export const ADD_CUSTOMER = 'ADD_CUSTOMER'

export const ADD_HOUR = 'ADD_WORK'
export const DELETE_HOUR = 'DELETE_HOUR'

export const NOTE_CREATE = 'NOTE_CREATE'
export const DELETE_NOTE = 'DELETE_NOTE'

export const ADD_TIME_SHEET = 'ADD_TIME_SHEET'
export const DELETE_TIME_SHEET = 'DELETE_TIME_SHEET'

export const ADD_WORK = 'ADD_WORK'
export const DELETE_WORK = 'DELETE_WORK'

export const CONTACT_CREATE = 'CONTACT_CREATE'
export const ADD_CONTACT = 'ADD_CONTACT'
export const CONTACT_UPDATE = 'CONTACT_UPDATE'
export const DELETE_CONTACT = 'DELETE_CONTACT'


export const LOCATION_CREATE = 'LOCATION_CREATE'
export const LOCATION_UPDATE = 'LOCATION_UPDATE'
export const LOCATION_DELETE = 'LOCATION_DELETE'
export const FETCH_LOCATION_SUCCESS = 'FETCH_LOCATION_SUCCESS';
export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';
export const SORT_PAGE = 'SORT_PAGE'

export const CREATE_TRAINING = 'CREATE_TRAINING'
export const CREATE_TRAINING_SUCCESS = 'CREATE_TRAINING_SUCCESS'
export const CREATE_TRAINING_ERROR = 'CREATE_TRAINING_ERROR'

export const DELETE_TRAINING = 'DELETE_TRAINING'
export const DELETE_TRAINING_SUCCESS = 'DELETE_TRAINING_SUCCESS'
export const DELETE_TRAINING_ERROR = 'DELETE_TRAINING_ERROR'

export const UPDATE_TRAINING = 'UPDATE_TRAINING'
export const UPDATE_TRAINING_SUCCESS = 'UPDATE_TRAINING_SUCCESS'
export const UPDATE_TRAINING_ERROR = 'UPDATE_TRAINING_ERROR'
